import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { Card, Col, Container, Row } from 'react-bootstrap-5';

import ProfileInformation from './steps/profile_information';
import CountySelect from './steps/county_select';
import StepProgress from './step_progress';
import { updateProfile } from '../../helpers/connect_api';
import { pick } from 'lodash';

export default function CompletionNew({
  brokerSpecialtyOptions,
  existingProfile,
  investorTypeOptions
}) {
  const [profile, setProfile] = useState(existingProfile || {});
  const [step, setStep] = useState(1);
  const [saving, setSaving] = useState(false);
  const hasRegions = profile.regions?.length > 0;

  const onRegionChange = (id, key, val) => {
    const regions = profile.regions.map(region => region.id === id ? { ...region, [key]: val } : region);
    setProfile({ ...profile, regions });
  };
  const onValueChange = (key, val) => setProfile({ ...profile, [key]: val });

  const onSave = () => {
    setSaving(true);

    const params = pick(profile, ['companyIsSelf', 'companyName', 'countryId', 'city', 'state', 'investorTypes']);


    updateProfile({ ...params, regions_attributes: profile.regions }, 'profile_completion')
      .then(() => window.location.href = '/connect/search');
  };

  const onNextStep = () => {
    if (step < totalSteps) {
      nextStep();
    } else {
      onSave();
    }
  };

  const nextStep = () => setStep(step + 1);
  const lastStep = () => setStep(step - 1);

  const totalSteps = hasRegions ? 2 : 1;
  const stepLabels =
    [
      { title: 'Profile Information', subTitle: 'Tell us about yourself' },
      { title: 'County Select', subTitle: 'Select your preferred counties' }
    ];

  const steps = () => {
    switch (step) {
    case 1:
      return (
        <ProfileInformation
          brokerSpecialtyOptions={brokerSpecialtyOptions}
          investorTypeOptions={investorTypeOptions}
          profile={profile}
          saving={saving}
          showSave={totalSteps == 1}
          onSubmit={onNextStep}
          onValueChange={onValueChange}
        />
      );
    case 2:
      return (
        <CountySelect
          profile={profile}
          saving={saving}
          onBack={lastStep}
          onSave={onSave}
          onValueChange={onRegionChange}
        />
      );
    default:
      return;
    }
  };
  const stepComponent = steps();

  return (
    <Container className="position-absolute top-50 start-50 translate-middle" fluid>
      <Row className="h-100">
        <Col className="overflow-auto h-100" style={{ '--animate-duration': '0.3s' }}>
          <Row className="justify-content-center align-items-center px-6">
            <Col md={12} xl={6}>
              <div>
                <h1 className="text-gradient premium-signup-header fw-bolder d-inline-block">Welcome!</h1>
              </div>
              You're just a few steps away to upgrade your prospecting power.
              Please fill out the information below so we can tailor the experience for you
            </Col>
            <Col md={12} xl={6}>
              <Card>
                <Card.Body>
                  {totalSteps > 1 && (
                    <StepProgress labels={stepLabels} step={step} total={totalSteps} />
                  )}
                  <SwitchTransition mode="out-in">
                    <CSSTransition
                      classNames={{
                        enter: 'animate__animated',
                        enterActive: 'animate__fadeIn',
                        exit: 'animate__animated',
                        exitActive: 'animate__fadeOut'
                      }}
                      key={step}
                      timeout={300}
                    >
                      {stepComponent}
                    </CSSTransition>
                  </SwitchTransition>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

CompletionNew.propTypes = {
  brokerSpecialtyOptions: PropTypes.object.isRequired,
  existingProfile: PropTypes.shape({}).isRequired,
  investorTypeOptions: PropTypes.object.isRequired
};
